import React, { useRef, useState } from 'react'
import Tab from "react-bootstrap/Tab";
import Nav from "react-bootstrap/Nav";
import { Modal, ModalBody } from "react-bootstrap";
import SignatureConsentForm from '../../../../../../../../utils/SignatureConsentForm';
import Loader from "../../../../../../../shared/Loader/Loader";

const SignEncounter = (props) => {
    const { isSign, setIsSign, providerName, setSearchParam, getSaveData } = props;
    const { canCoSign, coSignItemData, coSignList, isToBeCoSignedStatus, setSaveEncounterCoSignData, isOpenedFrom: isOpenedFromCoSignProp } = props?.coSignProps || {};
    const isSignatureCoSign = isOpenedFromCoSignProp === 'CoSign' && isToBeCoSignedStatus;

    const [activeTab, setActiveTab] = useState('Type');
    const [isLoading, setIsLoading] = useState(false);
    const childRef = useRef();
    const signExists = isSignatureCoSign ? coSignItemData?.ProviderSignaturePath : !!props?.initialDataData?.ProviderSignaturePath;

    const handleSign = () => {
        if (signExists) {
            if (props?.isOpenedFrom === "EncounterMenuBulk") {
                getSaveData("", "", "", 'SignExists')
                setIsSign(false);
                return;
            }
            if (isSignatureCoSign) {
                if (!coSignItemData) return;
                const coSignExists = !!coSignItemData?.ProviderSignaturePath;
                if (coSignExists) {
                    setSaveEncounterCoSignData([coSignItemData]);
                }
            } else {
                setSearchParam(prev => ({
                    ...prev,
                    EncounterStatus: 'Signed',
                    IsLinkedProviderSignature: 'true',
                }));
            }
            setIsSign(false);
            getSaveData("", "", "", 'Save Sign');
            return;
        }
        if (!activeTab) return;
        setIsLoading(true);
        // First paint the loader
        requestAnimationFrame(() => {
            // Let the loader render
            requestAnimationFrame(() => {
                switch (activeTab) {
                    case 'Type':
                        childRef.current?.saveTypedSignature();
                        break;
                    case 'Draw':
                        childRef.current?.saveDrawnSignature();
                        break;
                    case 'Upload':
                        childRef.current?.saveUploadedSignature();
                        break;
                }
            });
        });
    }
    // headerText is Staff Signature in Staff case
    let headerText = props?.isOpenedFrom === "AddNewProvider" ? (props?.headerText || 'Provider Signature') : props?.isOpenedFrom === 'User' ? 'User Signature' : props?.isOpenedFrom === 'PatientDefaultSignature' ? 'Patient’s Signature' : 'Sign Encounter';
    return (
        <>
            <Modal show={isSign} onHide={isSign} backdrop="static" keyboard={false} centered dialogClassName="hk-modal-v1 ar_sign_popup">
                <Modal.Body>
                    {isLoading ? <Loader /> : <></>}
                    <div className="d-flex align-items-center justify-content-between mb-12 px-10">
                        <div className="">
                            <p className="heading dark-clr fs-13">{headerText}</p>
                        </div>
                        <i className="icon-x-cros fs-20 dark-clr" onClick={() => setIsSign(false)}></i>
                    </div>
                    <SignatureConsentForm ref={childRef} name={providerName} activeTab={activeTab} setActiveTab={setActiveTab} setSearchParam={setSearchParam} setIsSign={setIsSign} setIsLoading={setIsLoading} getSaveData={getSaveData} {...props} />
                </Modal.Body>
                <div className="d-flex align-items-center pb-15 px-10 pt-2 br-top-1 za_br_light justify-content-end gap-2 ar_footer">
                    <button className='btn btn-outline  px-10 h-100 dark-clr' onClick={() => setIsSign(false)}>Cancel</button>
                    <button className='btn btn-Signed px-10 h-100' onClick={handleSign}>Sign</button>
                </div>
            </Modal>
        </>
    )
}

export default SignEncounter